export class Product {
  constructor(
    public id: number = 0,
    public name: string = '',
    public position: number = null,
    public image: string = ''
  ) {}
}
